"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _table = require("@bento-core/table");
var _TableService = require("./TableService");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/**
* Updates table row when table state is changed 1. (paginated action) and 2. filter action
*/
var TableController = function TableController(props) {
  var queryVariables = props.queryVariables,
    table = props.table;
  var _ref = (0, _TableService.getTableData)({
      queryVariables: queryVariables,
      table: table
    }),
    tableData = _ref.tableData;
  if (!tableData) {
    return /*#__PURE__*/_react.default.createElement(_core.Container, {
      maxWidth: "xl"
    }, /*#__PURE__*/_react.default.createElement(_core.CircularProgress, null));
  }
  /**
  * update rows
  * set selected rows isChecked to TRUE
  */
  var updateRows = (0, _TableService.setSelectedRows)(tableData, table);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_table.TableView, _extends({}, props, {
    tableRows: updateRows
  })));
};
var _default = TableController;
exports.default = _default;